"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.applyScrolling = exports.resetRoutableComponents = exports.RoutableContainer = exports.RoutableComponent = exports.history = void 0;
var BrowserHistory_1 = require("./BrowserHistory");
Object.defineProperty(exports, "history", { enumerable: true, get: function () { return BrowserHistory_1.history; } });
var RoutableComponent_1 = require("./RoutableComponent");
exports.RoutableComponent = RoutableComponent_1.default;
var RoutableContainer_1 = require("./RoutableContainer");
exports.RoutableContainer = RoutableContainer_1.default;
var RoutableComponentsManager_1 = require("./RoutableComponentsManager");
var ScrollListeners_1 = require("./ScrollListeners");
var applyScrolling = ScrollListeners_1.scrollListeners.applyScrolling;
exports.applyScrolling = applyScrolling;
var resetRoutableComponents = RoutableComponentsManager_1.RoutableComponentsManager.purge;
exports.resetRoutableComponents = resetRoutableComponents;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/routables/index.js
// module id = 42
// module chunks = 8